import { Button } from '@/components/ui/button';

export function ConnectYouTubeButton({ connected }: { connected: boolean }) {
  if (connected) {
    return (
      <Button variant="outline" disabled>
        YouTube conectado
      </Button>
    );
  }
  return (
    <Button asChild>
      <a href="/auth/youtube">Conectar YouTube</a>
    </Button>
  );
}
